import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import {
  detailsCrmUser,
  detailsGuestUser,
  logout,
} from "../actions/userAction";
import Spinner from "./Spinner";
import { AiFillNotification } from "react-icons/ai";
import { PiStudentBold } from "react-icons/pi";

export default function Header(props) {
  const { id } = useParams();
  //console.log(window.URL)
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { eventid } = useParams();

  const [logoUrl, setLogoUrl] = useState("");
  const guestCrm = JSON.parse(localStorage.getItem("guestCrm"));
  const guestUserLogin = useSelector((state) => state.guestUserLogin);
  const { userInfo } = guestUserLogin;
  const Navigate = useNavigate();
  const guestUserDetail = useSelector((state) => state.guestUserDetail);
  const { loading, userDetails, error } = guestUserDetail;

  const handleLogout = () => {
    dispatch(logout());
  };

  useEffect(() => {
    if (userInfo == undefined || userInfo == "") {
      window.location.href = `/login/guest/${id}`;
    }
    if (userDetails == undefined || userDetails.length == 0) {
      if (guestCrm) {
      } else {
        dispatch(detailsGuestUser());
      }
    }
    //console.log(userDetails)
  }, [dispatch, userInfo, userDetails]);

  return (
    <>
      <header className="header-section">
        <nav className="navbar navbar-expand-lg fixed-top" id="main_navbar">
          <div className="container">
            <div className="bran-se-logo">
              <a className="navbar-brand white-logo" href="/126">
                {" "}
                <img
                  src="/assets/img/SE-logo-white.webp"
                  alt="Search Education"
                  width="60%"
                />
              </a>
              <a className="navbar-brand color-logo" href="/126">
                {" "}
                <img
                  src="/assets/img/SE-logo.webp"
                  alt="Search Education"
                  width="60%"
                />
              </a>
            </div>

            {/* <div className="univer-login-user">
              <div className="d-flex flex-row align-items-center  user-info">
                {loading ? (
                  <Spinner />
                ) : (
                  <>
                    {userDetails ? (
                      <>
                       
                        {userDetails.Logo55x55 || userDetails?.Logo134x64 ? (
                          <>
                            <img
                              style={{ width: 100 }}
                              src={`https://doc.searcheducation.in/university/Logo134x64/${userDetails?.Logo134x64}`}
                              width="50"
                            />
                          </>
                        ) : userDetails?.INSTITUTE?.includes("Edvoy") ? (
                          <img
                            style={{ width: 100 }}
                            src={`https://doc.searcheducation.in/assets/img/edvoy.png`}
                            width="50"
                          />
                        ) : userDetails?.INSTITUTE?.includes("IDFC") ? (
                          <img
                            style={{ width: 100 }}
                            src={`https://doc.searcheducation.in/assets/img/idfc.png`}
                            width="50"
                          />
                        ) : userDetails?.INSTITUTE?.includes("Amber") ? (
                          <img
                            style={{ width: 100 }}
                            src={`https://doc.searcheducation.i /assets/img/amber.jpeg`}
                            width="50"
                          />
                        ) : (
                          <img
                            className="rounded-circle"
                            src="/assets/img/Deafult-user.png"
                            alt=""
                            width="40"
                          />
                        
                        )}
                        <div
                          className="d-flex flex-column justify-content-start ml-2"
                          style={{ padding: 15 }}
                        >
                          <span className="d-block font-weight-bold text-uppercase">
                            {guestCrm ? guestCrm?.Name : userDetails.GUEST_NAME}
                            &nbsp;&nbsp;&nbsp;&nbsp;
                          </span>

                          <span className="text-black-50">
                            <span className="univerity-tilte">
                              {" "}
                              {userDetails.INSTITUTE}
                            </span>{" "}
                            -{" "}
                            <i>
                              <b>
                                {userDetails.COUNTRY
                                  ? userDetails.COUNTRY
                                  : "INDIA"}
                              </b>
                            </i>
                          </span>
                        </div>
                        <div>
                          <a
                            className="btn btn-search-education"
                            style={{ color: "white" }}
                            onClick={(e) => handleLogout(e)}
                          >
                            <span
                              className="glyphicon glyphicon-log-out"
                              style={{ color: "white" }}
                            ></span>{" "}
                            Log out
                          </a>
                        </div>
                        {guestCrm ? (
                          <div
                            style={{
                              color: "#f26524",
                              marginTop: "-10px",
                              cursor: "pointer",
                              padding: "0 10px",
                              fontSize: "25px",
                            }}
                            onClick={() =>
                              (window.location.href = "/guest-activity/126")
                            }
                          >
                            <AiFillNotification />
                          </div>
                        ) : (
                          ""
                        )}

                        {guestCrm ? (
                          <div
                            style={{
                              color: "#f26524",
                              marginTop: "-10px",
                              cursor: "pointer",
                              padding: "0 10px",
                              fontSize: "25px",
                            }}
                            onClick={() =>
                              (window.location.href = "/important/contact/126")
                            }
                          >
                            <PiStudentBold />
                          </div>
                        ) : (
                          ""
                        )}
                      </>
                    ) : (
                      <></>
                    )}
                  </>
                )}
              </div>
            </div> */}

            <div class="account-section">
              <div class="account-info">
                {loading ? (
                  <Spinner />
                ) : (
                  <>
                    <div style={{ width: 100 }}>
                      {userDetails ? (
                        <>
                          {userDetails.Logo55x55 || userDetails?.Logo134x64 ? (
                            <>
                              <img
                                style={{ width: 100 }}
                                src={`https://doc.searcheducation.in/university/Logo134x64/${userDetails?.Logo134x64}`}
                                width="50"
                              />
                            </>
                          ) : userDetails?.INSTITUTE?.includes("Edvoy") ? (
                            <img
                              style={{ width: 20 }}
                              src={`https://doc.searcheducation.in/assets/img/edvoy.png`}
                              width="50"
                            />
                          ) : userDetails?.INSTITUTE?.includes("IDFC") ? (
                            <img
                              style={{ width: 20 }}
                              src={`https://doc.searcheducation.in/assets/img/idfc.png`}
                              width="50"
                            />
                          ) : userDetails?.INSTITUTE?.includes("Amber") ? (
                            <img
                              style={{ width: 20 }}
                              src={`https://doc.searcheducation.in/assets/img/amber.jpeg`}
                              width="50"
                            />
                          ) : (
                            <div class="avatar">
                              <svg
                                width="20"
                                height="20"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              >
                                <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2"></path>
                                <circle cx="12" cy="7" r="4"></circle>
                              </svg>
                            </div>
                          )}
                        </>
                      ) : (
                        ""
                      )}
                    </div>
                    <div class="account-details">
                      <p class="account-title">
                        {" "}
                        {guestCrm ? guestCrm?.Name : userDetails.GUEST_NAME}
                      </p>
                      <p class="account-location">
                        {" "}
                        <span className="univerity-tilte">
                          <span>{userDetails.INSTITUTE}</span> -{" "}
                          <i>
                            <b>
                              {userDetails.COUNTRY
                                ? userDetails.COUNTRY
                                : "INDIA"}
                            </b>
                          </i>
                        </span>
                      </p>
                    </div>
                  </>
                )}
              </div>

              <button class="logout-btn" onClick={(e) => handleLogout(e)}>
                LOG OUT
              </button>

              {guestCrm ? (
                <div
                  style={{
                    color: "#f26524",
                    marginTop: "-10px",
                    cursor: "pointer",
                    padding: "0 10px",
                    fontSize: "25px",
                  }}
                  onClick={() => (window.location.href = "/guest-activity/126")}
                >
                  <AiFillNotification />
                </div>
              ) : (
                ""
              )}

              {guestCrm ? (
                <div
                  style={{
                    color: "#f26524",
                    marginTop: "-10px",
                    cursor: "pointer",
                    padding: "0 10px",
                    fontSize: "25px",
                  }}
                  onClick={() =>
                    (window.location.href = "/important/contact/126")
                  }
                >
                  <PiStudentBold />
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
        </nav>
      </header>

      <section className="student-info">
        <div className="container-fluid p-0">
          <div className="student-information">
            {/* <div className="student-information-title">
                            <div className="row">
                                <div className="col-12 col-md-12 p-md-2 mt-1 text-center">
                                    <a className="" href="index.html"> <img src="../assets/img/SE-logo.webp" alt="Search Education" /></a>
                                </div>
                            </div>
                        </div> */}

            {props.children}
          </div>
        </div>
      </section>
      <section>
        <div className="footer-broder-top">
          <div className="container">
            <p className="mb-0">
              &copy; {new Date().getFullYear()}{" "}
              <a href="https://www.searcheducation.com/">SEARCHEDUCATION.COM</a>{" "}
              ALL RIGHTS RESERVED.
            </p>
          </div>
        </div>
      </section>
    </>
  );
}
